import { useParams } from 'react-router-dom';
import { BlogPostView } from '../components/blog/BlogPostView';
import { getBlogPost } from '../data/blog';
import { SITE } from '../data/site';
import { usePageSeo } from '../hooks/usePageSeo';
import { blogPostingJsonLd, PAGE_SEO } from '../lib/seo';
import { NotFoundContent } from './NotFoundPage';
import '../styles/blog-page.css';

export function BlogPostPage() {
  const { slug } = useParams();
  const post = slug ? getBlogPost(slug) : undefined;

  usePageSeo(
    post
      ? {
          title: `${post.title} | ${SITE.name}`,
          description: post.excerpt,
          path: `/blog/${post.slug}`,
          image: post.image,
          imageAlt: post.title,
          type: 'article',
          publishedTime: post.date,
          modifiedTime: post.date,
          authorName: post.author.name,
          jsonLd: blogPostingJsonLd(post),
        }
      : {
          ...PAGE_SEO.notFound,
          path: slug ? `/blog/${slug}` : '/404',
        },
  );

  if (!post) {
    return <NotFoundContent />;
  }

  return <BlogPostView post={post} />;
}
